var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column full-height"},[_vm._t("header"),_c('v-container',{ref:"scrollableContainer",staticClass:"justify-center align-content-start full-height",class:{
      'container-non-scrollable': !_vm.scrollable,
      'container-scrollable': _vm.scrollable,
    }},[_vm._t("default")],2),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }